@if (service.selectedItems.length) {
  <div fxFlex fxLayout="row" class="table-multi-actions">
    <div class="count">{{ service.selectedItems.length }} {{ 'common.selected' | translate }}</div>
    <div class="actions d-flex">
      <!-- <button
      *ngIf="listOptions.exportList && !listOptions.archivedList"
      mat-button
      class="btn-light export-list-btn"
      (click)="service.exportMultiple(service?.selectedItems, false, 'csv', params?.queryParams)"
      >
      <mat-icon class="mdi-icon" svgIcon="file-download-outline" [attr.size]="'16px'"></mat-icon>
      {{ 'common.export' | translate }}
    </button> -->
      @if (listOptions.cancelSelections) {
        <button mat-button class="btn-light export-list-btn" (click)="service.cancelSelections()">
          <mat-icon class="mdi-icon" svgIcon="cancelSelections" [attr.size]="'16px'"></mat-icon>
          {{ 'common.cancel-selections' | translate }}
        </button>
      }
      @for (operation of operations; track operation) {
        @if (!service.isArchived && listOptions.deleteMultiple && rolesPermissionsService.can(service.moduleName, 'delete')) {
          <button
            mat-button
            class="btn-light export-list-btn"
            (click)="service.openDialog(service.selectedItems, operation.type)"
          >
            <mat-icon class="mdi-icon" [svgIcon]="operation.icon" [attr.size]="'16px'"></mat-icon>
            <!--        {{ 'common.archive' | translate }}-->
            {{ 'common.' + operation.name | translate }}
          </button>
        }
      }
      @if (rolesPermissionsService.can(service.moduleName, 'deactivate')) {
        @if (listOptions.multipleDeactivate) {
          <button mat-button class="btn-light export-list-btn">
            <mat-icon class="mdi-icon" svgIcon="multipleDeactivate" [attr.size]="'16px'"></mat-icon>
            {{ 'common.deactivate' | translate }}
          </button>
        }
      }
      @if (!service.isArchived && listOptions.multipleExports) {
        <button mat-button [matMenuTriggerFor]="menu" class="btn-light export-list-btn">
          <mat-icon class="mdi-icon" svgIcon="multipleExports" [attr.size]="'16px'"></mat-icon>
          {{ 'common.export' | translate }}
        </button>
        <mat-menu class="export-menu" #menu="matMenu" xPosition="before">
          <!-- <div class="d-flex align-items-center justify-content-space-between">
        <span class="export-menu-title">{{ 'common.quick_control' | translate }}</span>
        <button mat-icon-button>
          <mat-icon class="mdi-icon" svgIcon="dots-vertical" [attr.size]="'16px'"></mat-icon>
        </button>
      </div> -->
          @for (exportAsItem of exportAsList; track exportAsItem) {
            <div fxFlex="" fxLayout="">
              <button
                fxFlex=""
                mat-menu-item
                (click)="service.exportMultiple(service?.selectedItems, false, exportAsItem?.type, params?.queryParams)"
                class="align-items-center in-menu-button"
              >
                <mat-icon class="mdi-icon in-menu-icon" [svgIcon]="exportAsItem.icon" [attr.size]="'14px'"></mat-icon>
                <span class="in-menu-span">{{ 'common.' + exportAsItem.type + '_file' | translate }}</span>
              </button>
              @if (listOptions.shareLink) {
                <button
                  fxFlex="40"
                  mat-menu-item
                  class="share-btn"
                  (click)="service.generateShareLink(exportAsItem.type, params?.queryParams)"
                >
                  {{ 'common.shareLinkBtn' | translate }}
                </button>
              }
            </div>
          }
          @if (!service.isArchived && listOptions.importList) {
            <button mat-menu-item (click)="service.openImportDialog(service)" class="align-items-center in-menu-button">
              <mat-icon class="mdi-icon in-menu-icon" svgIcon="file-download-outline" [attr.size]="'14px'"></mat-icon>
              <span class="in-menu-span">{{ 'common.import_file' | translate }}</span>
            </button>
          }
        </mat-menu>
      }
      @if (!service.isArchived) {
        @if (listOptions.assignApplication &&rolesPermissionsService.can(service.moduleName, 'assign-application')) {
          <button mat-button class="btn-light export-list-btn" (click)="service.openAssignAppsDialog(service)">
            <mat-icon class="mdi-icon" svgIcon="assign" [attr.size]="'16px'"></mat-icon>
            {{ 'common.assignApplication' | translate }}
          </button>
        }
      }
      @if (permissionsService?.permissions?.[service.moduleName]?.createUser || permissionsService.isOwnerPermission) {
        @if (listOptions.createMultipleUsers) {
          <button mat-button class="btn-light export-list-btn" (click)="service.createMultipleUsers()">
            <!-- (click)="service.exportMultiple(service?.selectedItems, false, 'csv', params?.queryParams)" -->
            <mat-icon class="mdi-icon" svgIcon="createMultipleUsers" [attr.size]="'16px'"></mat-icon>
            {{ 'common.create-user' | translate }}
          </button>
        }
      }
    </div>
  </div>
}
